import { ChangeEvent } from 'react';
// Normalize input by trimming whitespace to avoid empty input being sent to the backend.

export const normalizeInput = (input: string | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): string => {
  const value = typeof input === 'string' ? input : input.target.value;
  return value ? value.replace(/\s+/g, ' ').trim() : '';
};
